import { Fragment, useContext, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Seo from "../../components/utils/Seo";
import Base from "../Base";
import BodyDetailProduct from "./BodyDetailProduct";
import productsContext from "../../dataManager/context/productsContext";
import { getProduct } from "../../api/products/productsApi";
import Product from "../../entities/Product";

const DetailProductPage = (props) => {
  //context variable
  const { getOneProduct } = useContext(productsContext);

  //local state
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const { id } = useParams();

  useEffect(() => {
    async function fetchProduct() {
      const { data, error } = await getProduct(id);

      if (error) {
        setError("Erreur lors de la récupération du produit");
        setLoading(false);
      }

      setProduct(new Product(data));
      setLoading(false);
    }

    fetchProduct();
  }, []);

  return (
    <Fragment>
      <Seo
        title={loading ? "chargement..." : product.getName}
        description="Des ordinateurs de bonnes qualités"
      />
      <Base>
        <BodyDetailProduct product={product} loading={loading} error={error} />
      </Base>
    </Fragment>
  );
};

export default DetailProductPage;
